"use client";

import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";

export const ErrorElement = (props: { children?: React.ReactNode }) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-start gap-3">
      <p className="text-muted-foreground">{props.children ?? t("general.errorPageMessage")}</p>
      <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
        {t("general.errorPageRetryButton")}
      </Button>
    </div>
  );
};
